import React, { useState } from 'react';
import { Box, Divider } from '@mui/material';

interface CustomerListSideComponentProps {
    displayData: any;
    fullData?: any;
    setFullData?: any;
}

export const CustomerListSideComponent: React.FC<CustomerListSideComponentProps> = ({ displayData, fullData, setFullData }) => {
    const [selectedKey, setSelectedKey] = useState(null);

    const handleOnClick = (value: string, index: any) => {
        setSelectedKey(index);
        if (setFullData && fullData) {
            if (selectedKey === index) {
                setFullData(fullData);
                setSelectedKey(null);
            } else {
                const result = fullData.filter((dataRow) => dataRow.agent === value);
                setFullData(result);
            }
        }
    };

    return (
        <>
            {displayData &&
                displayData.map((row, index) => (
                    <Box
                        key={index}
                        onClick={() => handleOnClick(row.label, index)}
                        sx={{
                            textAlign: 'center',
                            color: 'text.primary',
                            paddingY: 1.5,
                            marginBottom: 1,
                            borderRadius: 1,
                            backgroundColor: selectedKey === index ? 'grey.300' : 'grey.100',
                            boxShadow: selectedKey === index ? 4 : 1,
                            transition: 'background-color 0.3s, box-shadow 0.3s'
                        }}
                    >
                        {row.label}
                    </Box>
                ))}
        </>
    );
};
